/* eslint-disable max-len */
import React from 'react';

var IconHide = function IconHide() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    fillRule: "nonzero",
    d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 1.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    fillRule: "nonzero",
    d: "M4.53 20.53l-1.06-1.06 16-16 1.06 1.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    fillRule: "nonzero",
    d: "M12 17c2.697 0 5.46-1.644 8.28-5-2.82-3.356-5.583-5-8.28-5-2.697 0-5.46 1.644-8.28 5 2.82 3.356 5.583 5 8.28 5zm-9.834-5.47C5.378 7.536 8.654 5.5 12 5.5c3.346 0 6.622 2.036 9.834 6.03l.379.47-.379.47C18.622 16.464 15.346 18.5 12 18.5c-3.346 0-6.622-2.036-9.834-6.03L1.787 12l.379-.47z"
  })));
};

export default IconHide;